import React from 'react';
import ReactDOM from 'react-dom';
import AppSetting from 'settings';
import App from './App';
import reportWebVitals from './reportWebVitals';

const renderApp = () =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <React.StrictMode>
      <AppSetting>
        <App />
      </AppSetting>
    </React.StrictMode>,
    document.querySelector('#root'),
  );

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
